// libs
import { useEffect, memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// actions
import { fetchExploreImages as _fetchExploreImages } from 'shared/store/details/services';

// defs
interface IExploreApiProps {
  productID: string;
  imageTagID: string;
  enabled: boolean;
  maxImages: number;
  fetchExploreImages: typeof _fetchExploreImages;
  exploreProductID?: string;
}

function ExploreApi({
  fetchExploreImages,
  enabled,
  maxImages,
  productID,
  exploreProductID,
  imageTagID,
}: IExploreApiProps) {
  useEffect(() => {
    if (enabled === false) {
      return;
    }

    // dont fetch if productID is undefined or empty
    if (isEmpty(productID)) {
      return;
    }

    if (exploreProductID === productID) {
      return;
    }

    fetchExploreImages({ productID, maxImages, imageTagID });
  }, [enabled, exploreProductID, fetchExploreImages, imageTagID, maxImages, productID]);

  return null;
}

export default memo(ExploreApi);
